export const deleteMenuItems = /* GraphQL */ `mutation DeleteMenuItems($input: inputDeleteBMMenuItems!) {
	deleteMenuItems(input: $input){
		deletedIds
		returnedCount
	}
}`
